"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  name: 'MyChannels',
  data() {
    return {
      channels: {
        instagram: '',
        telegram: '',
        whatsapp: '',
        twitter: ''
      }
    };
  },
  methods: {
    saveChannels() {
      alert('¡Canales registrados con éxito!');
    }
  }
};